import React, { useState, useEffect } from 'react';

function Estadisticas({ apiCentral }) {
  const [data, setData] = useState([]);
  

  useEffect(() => {
    fetch(`${apiCentral}/api/get/estadistica`)
      .then(res => {
        console.log("Respuesta de la API:", res);  // Verifica el objeto de respuesta
        if (res.ok) {
          return res.json();  // Solo convierte a JSON si la respuesta es correcta
        } else {
          throw new Error("Error en la respuesta de la API");
        }
      })
      .then(date => {
        console.log("Datos recibidos:", date);  // Verifica los datos antes de pasarlos a setData
        setData(date);
      })
      .catch(error => {
        console.error("Error al cargar los datos:", error);
      });
  }, []);

  return (
    <div className="dashboard-restaurantes-container">
      <h2 className="dashboard-restaurantes-title">Estadisticas</h2>
      <table className="restaurantes-data-table">
        <thead>
          <tr>
            <th>Nombre Restaurante</th>
            <th>Conecciones</th>
            <th>Pedidos</th>
            <th>ip</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((restaurant, index) => (
              <tr key={index}>
              <td style={{ textAlign: 'center' }}>{restaurant.nombreRestaurante}</td>
              <td style={{ textAlign: 'center' }}>{restaurant.conecciones}</td>
              <td style={{ textAlign: 'center' }}>{restaurant.pedidos}</td>
              <td style={{ textAlign: 'center' }}>{restaurant.ip}</td>
            
            </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">No hay datos disponibles</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default Estadisticas;
